<template>
  <div class="job" v-if="load">
    <div class="banner">
      <img
        :src="banner.cover"
        alt
      />
    </div>
    <!-- 2 -->
    <div class="row job-content">
      <div class="column small-12 medium-5 large-4">
        <h3>工作职位招聘</h3>
        <div class="row check-job" style="margin-bottom: 1.4rem">
          <div class="column small-3 medium-12" :class="{'is-active': showIndex === index}" v-for="(item,index) in list" :key="index" @click="checkJob(index)">{{item.title}}</div>
        </div>
      </div>
      <div class="column samll-12 medium-7 large-8" v-for="(item,index) in list" :key="index" v-show="showIndex === index">
        <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {RecruitInfo} from "@/api/index"
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      list: null,
      showIndex: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    checkJob(index){
      this.showIndex = index
    }
  },
  created() {
    RecruitInfo((res) => {
      this.load = true; 
       this.$emit('complete',true)
      if(res.code == 0){
        this.banner = res.data.banner;
        this.list = res.data.list;
      }
    })
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
    height: 43vw;
  }
}
.check-job{
  &>div{
    cursor: pointer;
    margin-top: 0.6rem;
    &.is-active{
      color: #e77500;
    }
  }
}
.job-content {
  padding: 1rem 0.6rem;
  h3 {
    width: fit-content;
    margin-bottom: 1rem;
    border-bottom: 4px solid #e77500;
  }
  h4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 0.4rem;
  }
}
@media print, screen and (min-width: 40em) {
  .job-content {
    padding: 2rem 0.75rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .job-content {
    padding: 3rem 1.75rem;
  }
}
@media screen and (min-width: 80em) {
  .job-content {
   padding: 4rem 3.125rem;
  }
}
@media print, screen and (max-width: 40em) {
  .small-3{
    width: 33.3%;
    text-align: center;
  }
}
</style>